module.exports = __webpack_public_path__ + "img/CSLHSC-1.cb593766.png";